import axios from "axios";

const axiosInstace = axios.create({
  baseURL: process.env.VUE_APP_PAGARME_ENDPOINT,
});

export const getBalancebyRecipient = async (recipient_id) => {
  return axiosInstace
    .get(`/balance/${recipient_id}`)
    .then((r) => r.data)
    .catch((e) => {
      console.log(e);
      return e;
    });
};

export const createRecipient = async (data) => {
  return axiosInstace
    .post("/recipient", {
      data: data,
    })
    .then((r) => r.data)
    .catch((e) => {
      console.error(e);
      return e;
    });
};

export const updateRecipient = async (id, data) => {
  return axiosInstace
    .patch("/recipient", {
      data,
      id,
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log(e);
      return e;
    });
};

export const getRecipient = async (recipient_id) => {
  return axiosInstace
    .get(`/recipient/${recipient_id}`)
    .then((r) => r.data)
    .catch((e) => {
      console.log(e);
      return null;
    });
};

export const getTransactions = async () => {
  return axiosInstace
    .get("/transactions")
    .then((r) => r.data)
    .catch((e) => {
      console.log(e);
      return e;
    });
};

export const getBalanceOperations = async (
  recipient_id,
  start_date,
  end_date,
  format,
) => {
  return axiosInstace
    .post("/balanceOperations", {
      recipient_id,
      start_date,
      end_date,
      format,
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log(e);
      return e;
    });
};

export const createTransfers = async (recipient_id, amount) => {
  return axiosInstace
    .post("/transfers", {
      recipient_id,
      amount,
    })
    .then((r) => r.data)
    .catch((e) => {
      console.log(e);
      return e;
    });
};
